import v3ApiClient from "./client";

const REFERENCE_BASE_PATH = "/v3/schedule/drafts/reference";
const AIRCRAFT_BASE_PATH = "/v3/aircraft";

export const scheduleDraftReferenceApi = {
    getAirports: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/airports`, { params }),

    getAircrafts: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/aircraft`, { params }),

    getFlightLegs: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-legs`, { params }),

    getAirportConstraints: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/airport-constraints`, { params }),

    getFlightRoutes: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-routes`, { params }),

    getFlightRouteById: (routeId) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-routes/${routeId}`),

    getRoutesByLeg: (departureAirport, arrivalAirport, params = {}) =>
        v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-routes/by-leg/${departureAirport}/${arrivalAirport}`, { params }),

    getBestMatchRoute: (departureAirport, arrivalAirport, params = {}) =>
        v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-routes/best-match/${departureAirport}/${arrivalAirport}`, { params }),

    getRecentOperations: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-operations/recent`, { params }),

    getOperationTransactionSummaries: (operationIds = []) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/flight-operations/transaction-summaries`, {
        params: { operation_ids: operationIds },
    }),

    getV1Schedules: (params = {}) => v3ApiClient.get(`${REFERENCE_BASE_PATH}/v1-schedules`, { params }),

    getAircraftAvailabilityWindows: (params = {}) => v3ApiClient.get(`${AIRCRAFT_BASE_PATH}/availability-windows`, { params }),
};

export default scheduleDraftReferenceApi;
